module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollableArea"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 d-flex px-0 text-center bg-darker dark font-weight-600"
  }, _vm._l((_vm.tabs2), function(tab) {
    return _c('div', {
      staticClass: "col-sm-4 px-0 py-3 text-uppercase pointer",
      class: {
        'selectedTab': tab.selected, 'centerTab': tab.centerTab, 'opacity-50': !tab.enabled()
      },
      on: {
        "click": function($event) {
          return _vm.changeTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 0), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid scrollThis"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [_c('div', {
    staticClass: "col-sm-8 bg-lighter"
  }, [_c(_vm.visibleArea, {
    tag: "div",
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('reservation-summary', {
    attrs: {
      "reservation": _vm.reservation,
      "selectedAgentComissions": _vm.selectedAgentComissions
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [_c('div', {
    staticClass: "col-sm-12 px-0 py-3 text-center bg-darkest lightest font-weight-600"
  }, [_vm._v("Summary")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-40848cfe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40848cfe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume.vue
// module id = 1810
// module chunks = 0